module.exports = __webpack_public_path__ + "assets/98379c1ee930130ed3b02c7fdddfd7df.mp3";